export default {
      id: "info-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#info",
      toString: function () {
        return this.url;
      }
    }